import RevertAdoptionModal from '@/views/app/Adoptions/Revert'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

function RevertAdoptions({ title }) {
  const { adoptionId } = useParams()
  const history = useHistory()

  return (
    <RevertAdoptionModal
      title={title}
      adoptionId={adoptionId}
      onClose={() => history.goBack()}
    />
  )
}

export default RevertAdoptions
